module.exports = __webpack_public_path__ + "static/media/valor2.07b3c62d.png";